import { createRejectOnErrorStatus } from '../../services/httpResponse';

const commonDirectives = angular.module('common-directives.module', []);

commonDirectives.directive('mainHeader', function () {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/common/main-header.html',
    controller: [
      '$scope',
      '$interval',
      'userService',
      'userViewService',
      '__env',
      function ($scope, $interval, userService, userViewService, __env) {
        $scope.$watch(
          function () {
            return userService.isAuthorized();
          },
          function (newValue) {
            $scope.authorized = newValue;
          }
        );

        $scope.__env = __env;

        $scope.clock = Date.now();
        $interval(function () {
          $scope.clock = Date.now();
        }, 1000);
      },
    ],
  };
});


commonDirectives.directive('fileChange', ['$parse', function ($parse) {

  return {
    require: 'ngModel',
    restrict: 'A',
    link: function ($scope, element, attrs, ngModel) {

      const attrHandler = $parse(attrs['fileChange']);

      const handler = function (e) {
        $scope.$apply(function () {
          attrHandler($scope, {$event: e, files: e.target.files});
        });
      };

      // Attach the handler to the HTML change event 
      element[0].addEventListener('change', handler, false);
    }
  };
}]);

commonDirectives.directive('mainMenu', function (
  userService,
  $window,
  $state,
  $rootScope,
  userViewService,
  eventService,
  gridletService,
  layoutService,
  $location,
  tipTokenService,
  toasterService,
  __env
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/common/main-menu.html',
    controller: [
      '$scope',
      function ($scope) {
        $scope.hasRightDash1 = false;
        $scope.hasRightDash2 = false;
        $scope.hasRightUsers = false;
        $scope.hasRightWebTip = false;
        $scope.hasRightPSA = false;
        $scope.hasRightKeyManager = false;
        $scope.hasRightAnalysis = false;
        $scope.hasRightPackages = false;
        $scope.hasRightPIS = false;
        $scope.hasRightTrackCondition = false;
        $scope.hasRightUpdateConfigurations = false;
        $scope.hasRightAnyAdmin = false;
        $scope.$watch(
          function () {
            return userService.isAuthorized();
          },
          function (newValue) {
            $scope.authorized = newValue;
            $scope.hasRightDash1 = userService.hasAccessDash1();
            $scope.hasRightDash2 = userService.hasAccessDash2();
            $scope.hasRightUsers = userService.hasAccessUsers();
            $scope.hasRightWebTip = userService.hasRMMView();
            $scope.hasRightPSA = userService.hasAccessPSA();
            $scope.hasRightKeyManager = userService.hasViewKeyManager();
            $scope.hasRightAnalysis = userService.hasAccessAnalysis();
            $scope.hasRightPackages = userService.hasAccessPackages();
            $scope.hasRightPIS = userService.hasAccessPIS();
            $scope.hasRightTrackCondition = userService.hasAccessTrackCondition();
            $scope.hasRightAssetConditionBogie = userService.hasAccessAssetCondition() && __env.profile === 'VALE';
            $scope.hasRightAssetConditionMonitoring = userService.hasAccessAssetCondition() && __env.profile === 'DEMO';
            $scope.hasAccessUpdateConfigurations = userService.hasAccessUpdateConfigurations();
            $scope.hasRightAnyAdmin = $scope.hasAccessUpdateConfigurations;
          }
        );
      },
    ],
    link: function (scope) {
      scope.currentTab = userViewService.getView();

      scope.isDashboardActive = function (dashboardView) {
        return scope.currentTab === dashboardView ||
          (dashboardView === 'dashboard' && scope.currentTab === 'trains') ||
          ($state.includes('train') && userViewService.getPreviousDashboard() === dashboardView);
      };

      layoutService.getAll().then(function (data) {
        scope.dashboardOne = {name: data.views.dashboard.name};
        scope.dashboardTwo = {name: data.views.dashboard2.name};
        scope.currentDashOne = angular.copy(scope.dashboardOne);
        scope.currentDashTwo = angular.copy(scope.dashboardTwo);
      });

      eventService.on('update-rights', function (e) {
        scope.hasRightDash1 = userService.hasAccessDash1();
        scope.hasRightDash2 = userService.hasAccessDash2();
        scope.hasRightUsers = userService.hasAccessUsers();
        scope.hasRightWebTip = userService.hasRMMView();
        scope.hasRightPSA = userService.hasAccessPSA();
        scope.hasRightKeyManager = userService.hasViewKeyManager();
        scope.hasRightAnalysis = userService.hasAccessAnalysis();
        scope.hasRightPackages = userService.hasAccessPackages();
        scope.hasRightPIS = userService.hasAccessPIS();
        scope.hasRightTrackCondition = userService.hasAccessTrackCondition();
      });

      eventService.on('update-view', function (e, args) {
        scope.currentTab = args.view;
      });

      const saveCustomizations = () => {
        if (scope.currentTab === 'dashboard' && !angular.equals(scope.currentDashOne, scope.dashboardOne)) {
          gridletService.saveViewName(
            scope.currentTab,
            scope.dashboardOne.name
          );
        } else if (scope.currentTab === 'dashboard2' && !angular.equals(scope.currentDashTwo, scope.dashboardTwo)) {
          gridletService.saveViewName(
            scope.currentTab,
            scope.dashboardTwo.name
          );
        }
      };

      const unbindCommon = $rootScope.$on('toggle-customization', function (
        event,
        args
      ) {
        if (!args.customize) {
          saveCustomizations();
        }
        if (scope.currentTab === 'dashboard') {
          scope.dashOneCustomizable = args.customize;
        } else if (scope.currentTab === 'dashboard2') {
          scope.dashTwoCustomizable = args.customize;
        }
      });
      scope.$on('$destroy', unbindCommon);

      scope.toAlarms = function () {
        $state.go('alarms');
      };

      scope.toDashboard = function () {
        $state.go('dashboard');
      };

      scope.toDashboard2 = function () {
        $state.go('dashboard2');
      };

      scope.toUsers = function () {
        $state.go('users');
      };

      scope.toKeyManager = function () {
        $state.go('key-manager');
      };

      const unbindDisableCustomization = $rootScope.$on(
        'disable-customization',
        function (event) {
          scope.dashOneCustomizable = false;
          scope.dashTwoCustomizable = false;
        }
      );
      scope.$on('$destroy', unbindDisableCustomization);

      scope.toTip = function () {
        tipTokenService.getTipToken().then(function (data) {
          if (data.tipPath) {
            const tipUrl =
              $location.protocol() + '://' + $location.host() + data.tipPath;
            $window.open(tipUrl, '_blank');
          } else {
            toasterService.error('tip.error-title', 'tip.error-body');
          }
        });
      };

      scope.toWebTip = () => {
        // Navigate to the 'webtip' state whose URL path has been changed to /otdr
        $state.go('webtip');
      };

      scope.toAnalysis = function () {
        $state.go('analysis');
      };

      scope.toPSA = function () {
        $state.go('psa');
      };

      scope.toPIS = function () {
        $state.go('pis');
      };

      scope.toFileManagement = function () {
        $state.go('files');
      };

      scope.toConfManagement = function () {
        $state.go('configuration');
      };

      scope.toTrackCondition = function () {
        $state.go('track-condition');
      };

      scope.toConditionMonitoring = function () {
        $state.go('condition-monitoring');
      };

      scope.toAdminConfiguration = function () {
        $state.go('admin-configuration');
      };
    },
  };
});

commonDirectives.directive('userMenu', function (
  userService,
  gridletService,
  userViewService,
  $rootScope,
  $uibModal,
  eventService,
  accountService,
  __env,
  $q,
  $log,
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/common/user-menu-module.html',
    link: function (scope) {
      const rejectOnErrorStatus = createRejectOnErrorStatus($q);
      let accountRequest = 0;
      scope.$on('$destroy', function () {
        accountRequest++;
      });
      scope.env = __env;
      eventService.on('update-view', function (e, args) {
        scope.currentTab = args.view;
        if (args.view === 'psa') {
          return;
        }
        if (args.view === 'dashboard') {
          scope.hasDashEdit = userService.hasDashOneEditRight();
        } else if (args.view === 'dashboard2') {
          scope.hasDashEdit = userService.hasDashTwoEditRight();
        }

        scope.gridlets = [{
          id: 'train-status-gridlet',
          title: 'dashboard.status-gridlet-module.gridlet-title',
          visible: userService.hasFleetStatusRead()
        }, {
          id: 'car-list-gridlet-vale',
          title: 'dashboard.car-list-gridlet-vale-module.gridlet-title',
          visible: userService.hasCarListRead()
        }, {
          id: 'fleet-gridlet',
          title: 'dashboard.fleet-gridlet-module.gridlet-title',
          visible: userService.hasFleetInfoRead() && scope.env.profile !== 'MELCO'
        }, {
          id: 'new-fleet-info-gridlet',
          title: 'dashboard.fleet-gridlet-module.gridlet-title',
          visible: userService.hasFleetInfoRead() && scope.env.profile === 'MELCO'
        }, {
          id: 'fleet-list-gridlet',
          title: 'dashboard.fleet-list.gridlet-title',
          visible: userService.hasFleetInfoRead() && scope.env.profile === 'MELCO'
        }, {
          id: 'train-software-status',
          title: 'dashboard.train-software-status-module.gridlet-title',
          visible: userService.hasTrainSoftwareStatusRead()
        }, {
          id: 'new-fleet-info-gridlet',
          title: 'QR Fleet Info',
          visible: userService.hasQRFleetInfoRead()
        }, {
          id: 'active-events-gridlet',
          title: 'dashboard.active-events-gridlet-module.gridlet-title',
          visible: userService.hasActiveEventRead() && scope.env.profile === 'LU'
        }, {
          id: 'active-events-list-gridlet',
          title: 'dashboard.active-events-gridlet-module.gridlet-title',
          visible: userService.hasActiveEventRead() && scope.env.profile !== 'LU'
        }, {
          id: 'history-events-gridlet',
          title: 'dashboard.history-events-gridlet-module.gridlet-title',
          visible: userService.hasEventHistoryRead()
        }, {
          id: 'audit-events-gridlet',
          title: 'dashboard.audit-events-gridlet-module.gridlet-title',
          visible: userService.hasAuditEventsRead()
        }, {
          id: 'system-status-gridlet',
          title: 'dashboard.system-status-gridlet-module.gridlet-title',
          visible: userService.hasSystemStatusRead()
        }, {
          id: 'condition-event-list-gridlet',
          title: 'dashboard.condition-event-list-gridlet-module.gridlet-title',
          visible: userService.hasConditionEventRead()
        }, {
          id: 'car-view-gridlet',
          title: 'dashboard.car-view-gridlet-module.gridlet-title',
          visible: userService.hasCarViewRead() && scope.env.profile !== 'VALE'
        }, {
          id: 'train-health-gridlet',
          title: 'dashboard.train-health-gridlet-module.gridlet-title',
          visible: userService.hasTrainHealthRead() && scope.env.profile !== 'VALE'
        }, {
          id: 'condition-alert-list-gridlet',
          title: 'dashboard.condition-alert-gridlet-module.gridlet-title',
          visible: userService.hasConditionAlertRead()
        }].filter(gridlet => gridlet.visible); // Check what gridlets have read permission and only keep those
      });

      scope.$watch(
        function () {
          return userService.getName();
        },
        function (newVal) {
          scope.name = newVal;
          scope.firstName = '';
          const request = ++accountRequest;
          if (!newVal) return;
          accountService.getCurrentUser().then(rejectOnErrorStatus).then(function (account) {
            if (request !== accountRequest) return;
            if (typeof account.name !== 'string' || !account.name.trim()) {
              $log.error('Cannot display account first name: current-user response has no name.');
              return;
            }
            scope.firstName = account.name.trim().split(/\s+/)[0];
          }, function (error) {
            if (request !== accountRequest) return;
            $log.error('Could not load the account first name.', error);
          });
        }
      );

      let unbindDisableCustomization = $rootScope.$on(
        'disable-customization',
        function (event) {
          scope.customizable = false;
          gridletService.setCustomizable(false);
          scope.customize = false;
        }
      );
      scope.$on('$destroy', unbindDisableCustomization);

      scope.logout = function () {
        eventService.broadcast('toggle-customization', {
          customize: false,
        });
        gridletService.setCustomizable(false);
        scope.customize = false;

        userService.logout();
      };

      scope.settings = function () {
        let modalInstance = $uibModal.open({
          component: 'accountModal',
          resolve: {
            type: function () {
              return 'view';
            },
            account: function () {
              return accountService.getCurrentUser();
            },
            currentUser: function () {
              return true;
            },
          },
        });

        modalInstance.result.then(function () {
        }, function () {
        });
      };

      scope.addGridlet = function (gridlet) {
        const id = gridlet.id;
        $rootScope.$emit('add-gridlet', {
          gridletId: id,
          currentTab: scope.currentTab,
        });
      };

      scope.resetWidgets = function () {
        const modalInstance = $uibModal.open({
          templateUrl: '/modules/modals/reset-widgets-module.html',
          controller: 'resetWidgetsModalController',
          resolve: {},
        });

        modalInstance.result.then(
          () => {
            gridletService.resetView(userViewService.getView());
            eventService.broadcast('restore-default-widgets');
          },
          () => {
          }
        );
      };

      scope.toggleCustomization = function (customize) {
        scope.customizable = customize;
        $rootScope.$emit('toggle-customization', {
          customize: customize,
        });

        gridletService.setCustomizable(customize);
        if (!customize) {
          // gridletService.saveLayout();
          eventService.broadcast('update-gridlet-menu');
        }
      };

      scope.$watch(
        function () {
          return userViewService.isCustomizableView();
        },
        function (newVal) {
          scope.isCustomizableView = newVal;
        }
      );
    },
  };
});

commonDirectives.directive('userSettings', function (userService) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/common/user-settings-module.html',
    controller: [
      '$scope',
      function ($scope) {
        $scope.$watch(
          function () {
            return userService.isAuthorized();
          },
          function (newValue) {
            $scope.authorized = newValue;
          }
        );
      },
    ],
  };
});
